import React from 'react';
import styled from 'styled-components';
import { formatBytes } from 'utils';
import FileIcon from '../../FileIcon';
import theme from '../../theme';

export type PublicAttachmentType = {
  url: string;
  mimetype: string;
  filename: string;
  uid: string;
  size?: number;
};

interface PublicAttachmentsProps {
  attachments: PublicAttachmentType[];
}

const PublicAttachments: React.FC<PublicAttachmentsProps> = ({
  attachments = [],
}) => (
    <>
      <label>Attachments</label>
      <StyledAttachments>
        {attachments.map(file => (
          <StyledFileItem
            key={file.uid}
            href={file.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FileIcon fileType={file.mimetype} iconWidth={23} />
            <StyledFileName>{file.filename}</StyledFileName>
            <StyledFileSize>({formatBytes(file.size, true)})</StyledFileSize>
          </StyledFileItem>
        ))}
      </StyledAttachments>
    </>
  );

export default PublicAttachments;

const StyledAttachments = styled.div`
  margin-top: 15px;
`;

const StyledFileItem = styled.a`
  display: flex;
  color: ${theme.gray8};
  margin-bottom: 10px;
  align-items: center;
`;

const StyledFileName = styled.span`
  margin: 0 4px 0 10px;
`;

const StyledFileSize = styled.span`
  color: ${theme.gray7};
`;
